import {
  Chip,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomButton,
  LoadingSkeleton,
  NoDataSkeleton,
  PaginationTable,
} from '../../../common/components';
import {
  AUDIT_TABLE_COLUMNS,
} from '../constants/auditConstants';
import {
  formatAuditTimestamp,
  formatAuditUser,
  formatHttpMethod,
  formatRequestPath,
  getStatusColor,
} from '../utils/formatters';

const ENDPOINT_MAX_CHARS = 35;

const AuditTable = ({
  actions = [],
  isLoading,
  page,
  totalPages,
  totalCount,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onSelectAction,
}) => {
  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <GeneralTableBox>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {AUDIT_TABLE_COLUMNS.map((column) => {
              const columnProps =
                column.id === 'endpoint'
                  ? {
                      sx: {
                        maxWidth: { xs: '28ch', md: '35ch' },
                        width: { xs: '28ch', md: '35ch' },
                      },
                    }
                  : {};

              return (
                <HeadTableCell key={column.id} {...columnProps}>
                  {column.label}
                </HeadTableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <TableBody>
          {actions.length > 0 ? (
            actions.map((action) => (
              <TableRow key={action.id} hover>
                <RowTableCell>{formatAuditTimestamp(action.created_at)}</RowTableCell>
                <RowTableCell>{formatAuditUser(action)}</RowTableCell>
                <RowTableCell>{action.module?.display_name || action.module?.key || '—'}</RowTableCell>
                <RowTableCell>
                  <Chip
                    label={formatHttpMethod(action.http_method)}
                    size="small"
                    color="primary"
                  />
                </RowTableCell>
                <RowTableCell
                  sx={{
                    maxWidth: { xs: '28ch', md: '35ch' },
                    width: { xs: '28ch', md: '35ch' },
                  }}
                >
                  {(() => {
                    const requestPath = formatRequestPath(action.request_path, action.endpoint);
                    const showTooltip = requestPath && requestPath.length > ENDPOINT_MAX_CHARS;
                    return (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        noWrap
                        title={showTooltip ? requestPath : undefined}
                        sx={{
                          display: 'block',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '100%',
                        }}
                      >
                        {requestPath}
                      </Typography>
                    );
                  })()}
                </RowTableCell>
                <RowTableCell>
                  <Chip
                    label={action.status_code || '—'}
                    size="small"
                    color={getStatusColor(action.status_code)}
                  />
                </RowTableCell>
                <RowTableCell>
                  <CustomButton
                    variant="text"
                    size="small"
                    onClick={() => onSelectAction(action)}
                  >
                    Ver detalles
                  </CustomButton>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron acciones registradas con los filtros seleccionados" />
          )}
        </TableBody>
      </Table>

      {totalCount > rowsPerPage && (
        <PaginationTable
          page={page}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </GeneralTableBox>
  );
};

export default AuditTable;
